const partnerSlider = document.querySelectorAll('.sc-partners-slider');
partnerSlider.forEach((el) => {
  const stickyStartPoint = el.querySelector('.partners-slider__animation-trigger');
  const stickyElement = el.querySelector('.partners-slider');
  const imagesSlider = el.querySelector('.partners-slider__images');
  const imagesWrapper = el.querySelector('.partners-slider__images-wrapper');
  let imagesWrapperWidth = imagesWrapper.offsetWidth;
  let imagesSliderWidth = imagesSlider.offsetWidth;
  let controllerPartnerSlider = null;
  controllerPartnerSlider = new ScrollMagic.Controller();
  let scene;

  const initStickyElementScene = () => {
    if (scene) {
      scene.destroy(true);
      controllerPartnerSlider = new ScrollMagic.Controller();
    }

    scene = new ScrollMagic.Scene({
      triggerElement: stickyStartPoint,
      duration: imagesSliderWidth * 0.6,
      triggerHook: 0,
    })
      .setTween(imagesSlider, { x: `-${imagesSliderWidth - imagesWrapperWidth}` })
      .setPin(stickyElement)
      .addTo(controllerPartnerSlider);

    if (isLocal()) {
      scene.addIndicators({ name: 'Sticky' });
    }
  };

  const updateDimensions = () => {
    imagesWrapperWidth = imagesWrapper.offsetWidth;
    imagesSliderWidth = imagesSlider.offsetWidth;
    if (imagesSliderWidth > imagesWrapperWidth) {
      initStickyElementScene();
    }
  };

  const debouncedUpdateDimensions = debounce(updateDimensions, 250);

  if (imagesSliderWidth > imagesWrapperWidth) {
    initStickyElementScene();
  }

  window.addEventListener('resize', debouncedUpdateDimensions);
});
